import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http'
import { Router } from '@angular/router';

interface validarUser{
  hasError:boolean,
  errorDisplay:string
} 
interface login{
  errorNum: number;
  account:string,
  accounts:object,
  accountType:string,
  email:string,
  idParent:string,
  name:string,
  hasError:boolean,
  errorDisplay:string,
  errorDesc:string,
  token:string,
  subscriber:string,
  username:string,
  requiredEmailUpdate:boolean,
  requiredPaperless:boolean,
  requiredQuestions:boolean,
  requiredAccountUpdate:boolean,
  requiredPasswordReset:boolean
} 
interface accountDetails{
    response(response: any, arg1: string);
  HasError:boolean,
  errorDisplay:string,
  SubscriberInfo: any[],
  ErrorDesc:string,
  AccounInfo: any
} 
interface doPayment{
  HasError:boolean,
  ErrorDesc:string,
  response:string
} 
interface getAcountsList{
  hasError:boolean,
  ErrorDesc:string,
  accounts:object,
} 
interface accountRefresh{
  AccountList: any;
  hasError:boolean,
  ErrorDesc:string,
  accounts:object,
}
interface addAccount{
  hasError:boolean,
  errorDisplay:string
} 
interface setAsDefaultAccount{
  hasError:boolean,
  errorDesc:string,
  errorDisplay:string
} 
interface getquestions{
  hasError:boolean,
  ErrorDesc:string,
} 
interface getChallengeQuestions2{
  hasError:boolean,
  ErrorDesc:string,
  email:string,
  subscriber:string
} 
interface getChallengeQuestions3{
  ResponseList: any;
  errorDesc: any;
  hasError:boolean,
  ErrorDesc:string,
  email:string,
  subscriber:string
} 
interface paperless{
  HasError:boolean,
  ErrorDesc:string,
} 
interface permissions{
  permission: object,
  idUserAPP:string,
  idParent:string,
  hasError:boolean,
  errorDesc:string,
}
interface userList{
  permission: object;
  hasError:boolean,
  errorDesc:string,
  HasError:boolean,
  ErrorDesc:string,
}
interface rolesList{
  permission: object;
  hasError:boolean,
  errorDesc:string,
  HasError:boolean,
  ErrorDesc:string,
}
interface idRoleList{
  permission: object;
  hasError:boolean,
  errorDesc:string,
  HasError:boolean,
  ErrorDesc:string,
}
interface updateRoles{
  listRoles: object;
  hasError:boolean,
  errorDesc:string,
  HasError:boolean,
  ErrorDesc:string,
}
interface createUser{
  hasError:boolean,
  errorDesc:string,
}
interface getPersonalData{
  HasError:boolean,
  ErrorDesc:string,
  BusinessName:string,
  CelularPhone:string,
  Email:string
}
interface updatePersonalData{
  hasError:boolean,
  errorDesc:string,
  Email:string
}
interface updatePersonalDir{
  HasError:boolean,
  ErrorDesc:string,
  Email:string
}
interface newPayment {
  errorDescription: any,
  errorNum: any;
  paymentOptions: any;
}
interface applyPayment {
  errorDescription: string,
  paymentToken: string,
  errorNum: number,
  redirectURL: string,
  hasError: boolean
}
interface verifyPaymentStatus {
  authorizationNumber: string;
  provisioningReference: string;
  errorDescription: string;
  errorDisplay: string;
  processEndState: boolean;
  hasError: boolean;
  errorNum: number;
  totalAmount: number;
  paymentStatus: string;
}
interface getHistoricoFacturas{
  HasError:boolean,
  ErrorDesc:string,
} 
interface getPaymentHistory{
  HasError:boolean,
  ErrorDesc:string,
} 
interface changeUser{
  HasError:boolean,
  hasError:boolean,
  ErrorDesc:string,
  errorDesc:string,
  errorDisplay:string
} 
interface changePassword{
  HasError:boolean,
  hasError:boolean,
  ErrorDesc:string,
  errorDesc:string,
  errorDisplay:string
} 
interface getPasswordRecoveryBySubscriber{
  response: any;
  HasError:boolean,
  hasError:boolean,
  ErrorDesc:string,
  errorDesc:string,
  errorDisplay:string
} 
interface validateAccount{
  HasError:boolean,
  hasError:boolean,
  ErrorDesc:string,
  errorDesc:string,
  accountType:string,
  accountSubType:string,
  errorDisplay:string
} 
interface getVerifyEmail{
  HasError:boolean,
  hasErrorField:boolean,
  ErrorDesc:string,
  errorDescField:string,
  errorDesc:string
} 
interface setchallengequestions{
  HasError:boolean,
  hasError:boolean,
  ErrorDesc:string,
  errorDesc:string
} 
interface validateSSNAndEmail{
  hasError:boolean,
  errorDesc:string,
  errorDisplay:string,
  message:string
} 
interface validatePassword{
  hasError:boolean,
  errorDesc:string,
  errorDisplay:string
} 
interface setPasswordUpdate{
  hasError:boolean,
  errorDesc:string,
  errorDisplay:string,
  response:string
}
interface updMessageStatus{
  ErrorDesc: string;
  HasError:boolean;
  hasError:boolean,
  errorDesc:string,
  errorDisplay:string,
  response:string
} 
interface getpasswordrecovery{
  token: string;
  newpassword: string;
  hasError:boolean,
  errorDesc:string,
  errorDisplay:string,
  response:string
} 

interface lastInvoice{
  hasError:boolean,
  errorDisplay:string
} 
interface getsubscriberList{
  hasError:boolean,
  errorDesc:string,
  accounts:any
} 
interface downloadLastPdf{
  UrlPDF:string,
  HasError:boolean,
  ErrorDesc:string,
}
interface deleteAccount{
  hasError:boolean,
  errorDisplay:string,
}
interface updateRegister {
  data: any,
  error: any;
  idTransaction: string;
  success: boolean;
  desc: String,
  hasError: boolean,
  errorDisplay: string,
  accountSubType: any,
  errorNum: number;
  account: string,
  accounts: object,
  accountType: string,
  email: string,
  idParent: string,
  name: string,
  errorDesc: string,
  token: string,
  subscriber: string,
  username: string,
  requiredEmailUpdate: boolean,
  requiredPaperless: boolean,
  requiredQuestions: boolean,
  requiredAccountUpdate: boolean,
  requiredPasswordReset: boolean
}
interface validateSubscriberUpdate {
  data: any,
  error: any;
  idTransaction: string;
  success: boolean;
  desc: String,
  hasError: boolean,
  errorDisplay: string,
  productType: any,
}
interface warrantyStatus {
  statusDescription: any;
  warrantyReclamationDate: any,
}
interface getHistoricalInvoiceOnDemand {
  hasError: boolean,
  ErrorDesc: string,
  binaryData:string,
}
@Injectable({
  providedIn: 'root'
})
export class Service {
  private urlService: string = "/api";
  constructor(private http:HttpClient, private router:Router) {}
  warrantyStatus(subscriber) {
    var form = new FormData();
    form.append("subscriber", subscriber);
    return this.http.post<warrantyStatus>(this.urlService + '/Authenticate/warrantyStatus', form);
  }
  validateSubscriberUpdate(subscriber,token){
    var form = new FormData();
    form.append("subscriber",subscriber);
    form.append("token",token);
    return this.http.post<validateSubscriberUpdate>(this.urlService + '/Authenticate/validateSubscriberUpdate', form);
  }

  getHistoricalInvoiceOnDemand(token, Ban, key) {
    var form = new FormData();
    form.append("Ban", Ban);
    form.append("token", token);
    form.append("key", key);
    return this.http.post<getHistoricalInvoiceOnDemand>(this.urlService + '/Authenticate/GetHistoricalInvoiceOnDemand', form);
  }
  updateRegister(subscriber,code,ssn,token){
    var form = new FormData();
    form.append("subscriber",subscriber);
    form.append("code",code);
    form.append("ssn",ssn);
    form.append("token",token);
    return this.http.post<updateRegister>(this.urlService + '/Authenticate/updAccountValidateCode', form);
  }
  login(Username, Password) {
    var form = new FormData();
    form.append("Username", Username);
    form.append("Password", Password);
    return this.http.post<login>(this.urlService + '/Authenticate/Login', form);
  }
  loginExternal(token) {
    var form = new FormData();
    form.append("token", token);
    return this.http.post<login>(this.urlService + '/Authenticate/loginExternal', form);
  }
  getPersonalData(token, BAN){
    var form = new FormData();
    form.append("token", token);
    form.append("BAN", BAN);
    return this.http.post<getPersonalData>(this.urlService + '/Authenticate/GetPersonalData', form);
  }  

  downloadLastPdf(Ban, year , format, token ){
    var form = new FormData();
    form.append("Ban", Ban);
    form.append("year", year);
    form.append("format", format);
    form.append("token", token);
    return this.http.post<downloadLastPdf>(this.urlService + '/Authenticate/DownloadLastPdf', form);
  }  

  updatePersonalData(token, BAN, PhoneNumber, PhoneNumber2, Email){
    var form = new FormData();
    form.append("token", token);
    form.append("BAN", BAN);
    form.append("PhoneNumber", PhoneNumber);
    form.append("PhoneNumber2", PhoneNumber2);
    form.append("Email", Email);
    return this.http.post<updatePersonalData>(this.urlService + '/Authenticate/UpdatePersonalData', form);
  }
  updatePersonalDir(token, BAN, AddressDet, AddressDet2, City, zip) {
    var form = new FormData();
    form.append("token", token);
    form.append("BAN", BAN);
    form.append("AddressDet", AddressDet);
    form.append("AddressDet2", AddressDet2);
    form.append("City", City);
    form.append("zip", zip);
    return this.http.post<updatePersonalDir>(this.urlService + '/Authenticate/UpdatePersonalDir', form);
  }
  getHistoricoFacturas(token, Ban, year, format) {
    var form = new FormData();
    form.append("Ban", Ban);
    form.append("token", token);
    form.append("year", year);
    form.append("format", format);
    return this.http.post<getHistoricoFacturas>(this.urlService + '/Authenticate/GetHistoricalInvoicesNew', form);
  }
  getPaymentHistory(token, Ban, year) {
    var form = new FormData();
    form.append("Ban", Ban);
    form.append("token", token);
    form.append("year", year);
    return this.http.post<getPaymentHistory>(this.urlService + '/Authenticate/GetPaymentHistory', form);
  }
  accountDetails(token,subscriber,account){
    var form = new FormData();
    form.append("token", token);
    form.append("subscriber", subscriber);
    form.append("account", account);
    return this.http.post<accountDetails>(this.urlService + '/Authenticate/AccountDetails', form);
  }
  getSubscriberList(account,subscriber,token,page,pageSize){
    
    var form = new FormData();
    form.append("subscriber", subscriber);
    form.append("account", account);
    form.append("token", token);
    form.append("page", page);
    form.append("pageSize", pageSize);
    return this.http.post<getsubscriberList>(this.urlService + '/Authenticate/Getsubscriberlist', form);
  }
  
  addUser(Account, Amount, token) {
    var form = new FormData();
    form.append("Account", Account);
    form.append("Amount", Amount);
    form.append("token", token);
    return this.http.post<doPayment>(this.urlService + '/Authenticate/DoPayment', form);
  }
  doPayment(Account, Amount, token) {
    var form = new FormData();
    form.append("Account", Account);
    form.append("Amount", Amount);
    form.append("token", token);
    return this.http.post<doPayment>(this.urlService + '/Authenticate/DoPayment', form);
  }
  getAcounts(token) {
    var form = new FormData();
    form.append("token", token);
    return this.http.post<getAcountsList>(this.urlService + '/Authenticate/GetAcounts', form);
  }
  accountRefresh(token) {
    var form = new FormData();
    form.append("token", token);
    return this.http.post<accountRefresh>(this.urlService + '/Authenticate/accountRefresh', form);
  }
  addAccount(account,ssn,defaultAccount,token) {
    var form = new FormData();
    form.append("token", token);
    form.append("account", account);
    form.append("ssn", ssn);
    form.append("setAsDefaultAccount", defaultAccount);
    return this.http.post<addAccount>(this.urlService + '/Authenticate/addAccount', form);
  }
  deleteAccount(token,account) {
    var form = new FormData();
    form.append("token", token);
    form.append("account", account);
    return this.http.post<deleteAccount>(this.urlService + '/Authenticate/deleteAccount', form);
  }
  setAsDefaultAccount(account,subscriber,accountType,accountSubType,productType,token) {
    var form = new FormData();
    form.append("token", token);
    form.append("account", account);
    form.append("subscriber", subscriber);
    form.append("accountType", accountType);
    form.append("accountSubType", accountSubType);
    form.append("productType", productType);
    return this.http.post<setAsDefaultAccount>(this.urlService + '/Authenticate/setAsDefaultAccount', form);
  }
  getquestions(token) {
    var form = new FormData();
    form.append("token", token);
    return this.http.post<getquestions>(this.urlService + '/Authenticate/GetQuestions', form);
  }
  getVerifyEmail(email) {
    var form = new FormData();
    form.append("email", email);
    return this.http.post<getVerifyEmail>(this.urlService + '/Authenticate/GetVerifyEmail', form);
  }
  getChallengeQuestions2(token) {
    var form = new FormData();
    form.append("token", token);
    return this.http.post<getChallengeQuestions2>(this.urlService + '/Authenticate/GetChallengeQuestions2', form);
  }

  getChallengeQuestions3(subscriber) {
    var form = new FormData();
    form.append("subscriber", subscriber);
    return this.http.post<getChallengeQuestions3>(this.urlService + '/Authenticate/GetChallengeQuestions', form);
  }

  getPasswordRecoveryBySubscriber(subscriber, email, sms) {
    var form = new FormData();
    form.append("subscriber", subscriber);
    form.append("email", email);
    form.append("sms", sms);
    return this.http.post<getPasswordRecoveryBySubscriber>(this.urlService + '/Authenticate/GetPasswordRecoveryBySubscriber', form);
  }

  validateAccount(account) {
    var form = new FormData();
    form.append("account", account);
    return this.http.post<validateAccount>(this.urlService + '/Authenticate/validateAccount', form);
  }
  changePassword(token, password, newPassword) {
    var form = new FormData();
    form.append("token", token);
    form.append("password", password);
    form.append("newPassword", newPassword);
    return this.http.post<getpasswordrecovery>(this.urlService + '/Authenticate/ChangePassword', form);
  }

  updatePaperless(Ban, token) {
    var form = new FormData();
    form.append("Ban", Ban);
    form.append("token", token);
    return this.http.post<paperless>(this.urlService + '/Authenticate/UpdateBillParameters', form);
  }
  permissions(token,accountType,name,lastName) {
    var form = new FormData();
    form.append("token", token);
    form.append("accountType", accountType);
    form.append("name", name);
    form.append("lastName", lastName);
    return this.http.post<permissions>(this.urlService + '/Authenticate/permissions', form);
  }
  userList(idUser,idParent) {
    var form = new FormData();
    form.append("idUser", idUser);
    form.append("idParent", idParent);
    return this.http.post<userList>(this.urlService + '/Authenticate/userList', form);
  }
  rolesList() {
    var form = new FormData();
    return this.http.post<rolesList>(this.urlService + '/Authenticate/rolesList', form);
  }
  idRoleList(idRole) {
    var form = new FormData();
    form.append("idRole", idRole);
    return this.http.post<idRoleList>(this.urlService + '/Authenticate/idRoleList', form);
  }
  idUserRoleList(idUser) {
    var form = new FormData();
    form.append("idUser", idUser);
    return this.http.post<idRoleList>(this.urlService + '/Authenticate/idUserRoleList', form);
  }

  createUser(token,idUserAPP,idParent,idRole,name,lastname,email,phoneNumber,acount,listRoles,rol) {
    var data = {
      token: token,
      idUserAPP: idUserAPP,
      idParent: idParent,
      idRole: idRole,
      name: name,
      lastname: lastname,
      email: email,
      phoneNumber: phoneNumber,
      acount: acount,
      rol: rol,
      source:'BUSINESS',
      roles: listRoles
    };
    return this.http.post<createUser>(this.urlService + '/Authenticate/createUser', data);
  }
  delete(idUserFk,idUserAPP,idParent,token) {
    var form = new FormData();
    form.append("idUserAPP", idUserAPP);
    form.append("idParent", idParent);
    form.append("idUserFk", idUserFk);
    form.append("token", token);
    return this.http.post<createUser>(this.urlService + '/Authenticate/deleteUser', form);
  }
  updateRoles(listRoles) {
    var data = {
      roles: listRoles
    };
    return this.http.post<updateRoles>(this.urlService + '/Authenticate/updateRoles', data);
  }
  validateSSNAndEmail(account, SSN, Email, Code) {
    var form = new FormData();
    form.append("account", account);
    form.append("SSN", SSN);
    form.append("Email", Email);
    form.append("Code", Code);
    return this.http.post<validateSSNAndEmail>(this.urlService + '/Authenticate/RegisterUserValidateSSNAndEmail', form);
  }
  updMessageStatus(account, token, id_message) {
    var form = new FormData();
    form.append("account", account);
    form.append("token", token);
    form.append("id_message", id_message);
    return this.http.post<updMessageStatus>(this.urlService + '/Authenticate/UpdMessageStatus', form);
  }
  setchallengequestions(token, questionID, response) {
    var form = new FormData();
    form.append("token", token);
    form.append("questionID", questionID);
    form.append("response", response);
    return this.http.post<setchallengequestions>(this.urlService + '/Authenticate/SetChallengeQuestions', form);
  }
  getpasswordrecovery(subscriber, ResponseList) {
    var form = new FormData();
    form.append("subscriber", subscriber);
    form.append("ResponseList", ResponseList);
    return this.http.post<getpasswordrecovery>(this.urlService + '/Authenticate/Getpasswordrecovery', form);
  }
  setPasswordUpdate(token, currentPassword, newPassword) {

    var form = new FormData();
    form.append("token", token);
    form.append("currentPassword", currentPassword);
    form.append("newPassword", newPassword);
    return this.http.post<setPasswordUpdate>(this.urlService + '/Authenticate/SetPasswordUpdate', form);
  }
  changeUser(token, email) {
    var form = new FormData();
    form.append("token", token);
    form.append("email", email);
    return this.http.post<changeUser>(this.urlService + '/Authenticate/SetEmailAsUserAccount', form);
  }
  registerUser(account,subscriber, ssn, email, password, code) {
    var form = new FormData();
    form.append("account", account);
    form.append("subscriber", subscriber);
    form.append("ssn", ssn);
    form.append("email", email);
    form.append("password", password);
    form.append("code", code);
    form.append("source", "WHOLESALE");
    return this.http.post<validatePassword>(this.urlService + '/Authenticate/RegisterUser', form);
  } 
  newPayment(productId, offerId) {
    var form = new FormData();
    form.append("productId", productId);
    form.append("merchantCodeId", offerId);
    return this.http.post<newPayment>(this.urlService + '/Authenticate/newPayment', form);
  }  
  applyPayment(offerId,productId, paymentOptionId, paymentAmount, customerEmail, subscriberNumber, subscriberAccountNumber, subscriberFullName, subscriberAddress1, subscriberAddress2, subscriberCity, subscriberState, subscriberZipCode, transactionDescription,banSend,subscribeSend,locationId,invoiceNumber) {
    var form = new FormData();
    form.append("productId", btoa(productId));
    form.append("paymentOptionId", btoa(paymentOptionId));
    form.append("paymentAmount", btoa(paymentAmount));
    form.append("customerEmail", btoa(customerEmail));
    form.append("subscriberNumber", btoa(subscriberNumber));
    form.append("subscriberAccountNumber", btoa(subscriberAccountNumber));
    form.append("subscriberFullName", btoa(subscriberFullName));
    form.append("subscriberAddress1", btoa(subscriberAddress1));
    form.append("subscriberAddress2", btoa(subscriberAddress2));
    form.append("subscriberCity", btoa(subscriberCity));
    form.append("subscriberState", btoa(subscriberState));
    form.append("subscriberZipCode", btoa(subscriberZipCode));
    form.append("transactionDescription", btoa(transactionDescription));
    form.append("offerId", offerId);
    form.append("subscriberAccountNumberSend", banSend);
    form.append("receiverSubsNumber",subscribeSend);
    form.append("locationId",locationId);
    form.append("invoiceNumber",invoiceNumber);
    return this.http.post<applyPayment>(this.urlService + '/Authenticate/applyPayment', form);
  }
  verifyPaymentStatus(paymentToken) {
    var form = new FormData();
    form.append("paymentToken", paymentToken);
    return this.http.post<verifyPaymentStatus>(this.urlService + '/Authenticate/verifyPaymentStatus', form);
  }
//revisar
  lastInvoice(Ban, year, format, token) {
    var form = new FormData();
    form.append("Ban", Ban);
    form.append("year", year);
    form.append("format", format);
    form.append("token", token);
    return this.http.post<getpasswordrecovery>(this.urlService + '/Authenticate/LastInvoice', form);
  } 
  //fin revisar
}
